import Step10 from './Step10';

export default Step10;
